/**
 * Thank You Slide Component
 * Final slide with business card image
 */

import React from 'react';
import { BottomNavigation } from '../../../components/shared/Navigation';
import { NavigationProps } from '../../../types/slideTypes';

interface ThankYouSlideProps extends NavigationProps {}

export const ThankYouSlide: React.FC<ThankYouSlideProps> = ({
  currentSlide,
  totalSlides,
  onPrevious,
  onNext,
  onGoToSlide,
}) => {
  return (
    <div
      className="h-full flex flex-col relative"
      style={{ backgroundColor: '#FFFFFF' }}
    >
      {/* Main Content - Centered */}
      <div className="flex-1 flex flex-col items-center justify-center p-4 md:p-6 lg:p-8">
        {/* Title */}
        <h1
          className="font-bold text-black text-center mb-8 md:mb-12 lg:mb-16"
          style={{ fontSize: 'clamp(3rem, 8vw, 4.5rem)' }}
        >
          Thank You
        </h1>

        {/* Business Card Image - Centered */}
        <div className="flex justify-center items-center w-full">
          <img
            src="/assets/Business_Card.png"
            alt="Business Card"
            style={{ width: '315px', maxWidth: '100%' }}
          />
        </div>
      </div>

      {/* Logo - Aligned with Content Slides - Responsive */}
      <div className="absolute top-12 left-0 right-0">
        <div className="max-w-7xl mx-auto pl-4 md:pl-8 lg:pl-[116px]">
          <img src="/assets/logo_black.png" alt="Logo" className="max-w-[200px]" />
        </div>
      </div>

      {/* 50px Dark Footer - GPU accelerated gradient */}
      <div
        className="absolute bottom-0 w-full"
        style={{
          height: '50px',
          background: 'linear-gradient(180deg, #1a1a1a 0%, #2d2d2d 100%)',
          boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.3)',
          willChange: 'transform',
          transform: 'translateZ(0)',
        }}
      />

      {/* Bottom Navigation with Title Slide Styling */}
      <BottomNavigation
        currentSlide={currentSlide}
        totalSlides={totalSlides}
        onPrevious={onPrevious}
        onNext={onNext}
        onGoToSlide={onGoToSlide}
      />
    </div>
  );
};
